// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__aurD7","loading_dot":"styles_loading_dot__OKOY-","dot":"styles_dot__tKAqS"};